<template>
    <!--弹窗-->
    <el-dialog width="800px" class="media_dialog" :title="title" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" top="8vh">
        <div class="media">
            <div class="media-left">
                <img class="media-object" :src="formData.image_url" alt="">
            </div>
            <div class="media-body">
                <div>{{formData.title}}</div>
                <div class="media-asin">
                    <span class="product-asin">{{formData.asin}}</span>
                </div>
                <!-- <div>追踪关键词：100 个</div> -->
            </div>
        </div>
        <div class="media-txt">请输入要监控的关键字或关键短语（每行一个）：</div>
        <el-form ref="formData" :model="formData">
            <el-form-item>
                <el-input
                    v-if="checked"
                    v-model="str"
                    onkeyup="value=value.replace(/[^\r\n0-9 a-zA-Z_-]/g,'')"
                    :rows="15"
                    type="textarea"
                    style="width: 760px;"
                    placeholder="输入竞品ASIN，已换行区分"
                    @input="oninput"
                >
                </el-input>
                <el-input
                    v-else
                    v-model="str"
                    :rows="15"
                    type="textarea"
                    style="width: 760px;"
                    placeholder="输入竞品ASIN，已换行区分"
                    @input="oninput"
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <div class="checked_item">
                    <div>
                        <el-checkbox v-model="checked" @change="change"></el-checkbox>
                        删除特殊字符（，？！&*%$@#，等等）
                    </div>
                    <span style="margin-right: 20px">关键字总数：<span style="color: #62cb31 !important">{{arr.length}}</span></span>
                </div>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
import { str_arr, str_arr_no_limit } from "@/utils/method";
export default {
    data() {
        return {
            loading: false,
            checked: true,
            arr: [],
            str: ""
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 同步关键词
        asin_str(str) {
            this.str = str;
            this.oninput(this.str);
        },
        //单选框方法
        change(val) {
            if (val) {
                this.str = this.str.replace(/[^\r\n0-9 a-zA-Z_-]/g, "");
                this.oninput(this.str);
            }
        },
        //输入框方法
        oninput(val) {
            let str = null;
            if (this.checked) {
                str = val.replace(/[^\r\n0-9 a-zA-Z_-]/g, "");
                this.arr = str_arr(str);
            } else {
                str = val;
                this.arr = str_arr_no_limit(str);
            }
        },
        // 保存信息
        submitForm() {
            this.loading = true;
            api.mod_keyword({ id: this.formData.id, keywords: this.arr })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            message: "编辑关键词成功",
                            type: "success"
                        });
                        this.$emit("Refresher", this.formData);
                        this.handleClose(false);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面！"
                    });
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.str = "";
            this.arr = [];
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.media {
    display: flex;
    align-items: flex-start;
}
.media-left {
    padding: 4px 8px 4px 4px;
    box-sizing: border-box;
}
.media-object {
    vertical-align: middle;
    border-style: none;
    width: 70px;
    height: 70px;
}
.media-body {
    font-size: 13px;
    color: #6a6c6f;
    flex: 1;
    box-sizing: border-box;
}
.media-asin {
    margin: 4px 0;
    box-sizing: border-box;
}
.product-asin {
    vertical-align: middle;
}
.media-txt {
    font-size: 13px;
    color: #6a6c6f;
    margin: 10px 0 10px 0;
}
.checked_item {
    display: flex;
    justify-content: space-between;
}
/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
/deep/ .el-form-item {
    margin-bottom: 6px !important;
}
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
